// // app/components/form-sections/EvidenceExperienceSection.jsx
// "use client";

// import { useState, useRef, useEffect } from "react";
// import Field from "../ui/Field";
// import CheckboxDropdown from "../ui/CheckboxDropdown";
// import Select from "../ui/Select";
// import { HistoryDatalist } from "../ui/HistoryDatalist";
// import Spinner from "../ui/Spinner";

// export default function EvidenceExperienceSection({
//   /* Evidence props */
//   achievementOpts,
//   hardOpts,
//   softOpts,
//   reasonOpts,
//   selectedAchievements,
//   selectedHard,
//   selectedSoft,
//   selectedReasons,
//   updateFromMulti,
//   appendToDelimitedField,

//   /* Experience props */
//   form,
//   setField,
//   pushHistory,
//   history,
//   aiExperience,
//   aiBusy,
//   aiGlow,
//   aiPresets = [],
// }) {
//   // local inputs for custom quick-adds
//   const [customAchievement, setCustomAchievement] = useState("");
//   const [customHard, setCustomHard] = useState("");
//   const [customSoft, setCustomSoft] = useState("");
//   const [customReason, setCustomReason] = useState("");

//   const expRef = useRef(null);
//   useEffect(() => {
//     if (aiGlow) {
//       expRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
//     }
//   }, [aiGlow]);

//   return (
//     <div className="grid gap-8 mt-6">
//       {/* ===== Evidence ===== */}
//       <div className="grid gap-6">
//         {/* Achievements */}
//         <Field label="Achievements">
//           <CheckboxDropdown
//             options={achievementOpts}
//             selected={selectedAchievements}
//             onChange={(vals) => updateFromMulti("achievements", achievementOpts, vals, "semicolon")}
//             placeholder="— Select achievements —"
//           />
//           <div className="mt-2 flex flex-wrap items-center gap-2">
//             <button
//               type="button"
//               onClick={() =>
//                 appendToDelimitedField(
//                   "achievements",
//                   "Dual Enrollment (college coursework with A/B grades)",
//                   "semicolon"
//                 )
//               }
//               className="rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-semibold hover:bg-slate-100"
//             >
//               + Dual Enrollment
//             </button>
//             <div className="flex items-center gap-2">
//               <input
//                 value={customAchievement}
//                 onChange={(e) => setCustomAchievement(e.target.value)}
//                 placeholder="Custom achievement…"
//                 className="w-56 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/30"
//               />
//               <button
//                 type="button"
//                 onClick={() => {
//                   appendToDelimitedField("achievements", customAchievement, "semicolon");
//                   setCustomAchievement("");
//                 }}
//                 className="rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-1.5 text-white text-xs font-semibold shadow-md hover:from-teal-700 hover:to-orange-700"
//               >
//                 Add
//               </button>
//             </div>
//           </div>
//         </Field>

//         {/* Hard Skills */}
//         <Field label="Hard Skills">
//           <CheckboxDropdown
//             options={hardOpts}
//             selected={selectedHard}
//             onChange={(vals) => updateFromMulti("hard_skills", hardOpts, vals, "comma")}
//             placeholder="— Select hard skills —"
//           />
//           <div className="mt-2 flex flex-wrap items-center gap-2">
//             <button
//               type="button"
//               onClick={() => appendToDelimitedField("hard_skills", "Java", "comma")}
//               className="rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-semibold hover:bg-slate-100"
//             >
//               + Java
//             </button>
//             <div className="flex items-center gap-2">
//               <input
//                 value={customHard}
//                 onChange={(e) => setCustomHard(e.target.value)}
//                 placeholder="Custom hard skill…"
//                 className="w-56 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/30"
//               />
//               <button
//                 type="button"
//                 onClick={() => {
//                   appendToDelimitedField("hard_skills", customHard, "comma");
//                   setCustomHard("");
//                 }}
//                 className="rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-1.5 text-white text-xs font-semibold shadow-md hover:from-teal-700 hover:to-orange-700"
//               >
//                 Add
//               </button>
//             </div>
//           </div>
//         </Field>

//         {/* Soft Skills */}
//         <Field label="Soft Skills">
//           <CheckboxDropdown
//             options={softOpts}
//             selected={selectedSoft}
//             onChange={(vals) => updateFromMulti("soft_skills", softOpts, vals, "comma")}
//             placeholder="— Select soft skills —"
//           />
//           <div className="mt-2 flex flex-wrap items-center gap-2">
//             <button
//               type="button"
//               onClick={() => appendToDelimitedField("soft_skills", "Leadership & Initiative", "comma")}
//               className="rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-semibold hover:bg-slate-100"
//             >
//               + Leadership & Initiative
//             </button>
//             <div className="flex items-center gap-2">
//               <input
//                 value={customSoft}
//                 onChange={(e) => setCustomSoft(e.target.value)}
//                 placeholder="Custom soft skill…"
//                 className="w-56 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/30"
//               />
//               <button
//                 type="button"
//                 onClick={() => {
//                   appendToDelimitedField("soft_skills", customSoft, "comma");
//                   setCustomSoft("");
//                 }}
//                 className="rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-1.5 text-white text-xs font-semibold shadow-md hover:from-teal-700 hover:to-orange-700"
//               >
//                 Add
//               </button>
//             </div>
//           </div>
//         </Field>

//         {/* Specific Reasons */}
//         {/* <Field label="Specific Reasons">
//           <CheckboxDropdown
//             options={reasonOpts}
//             selected={selectedReasons}
//             onChange={(vals) => updateFromMulti("reasons", reasonOpts, vals, "reasons")}
//             placeholder="— Select reasons —"
//           />
//           <div className="mt-2 flex flex-wrap items-center gap-2">
//             <button
//               type="button"
//               onClick={() =>
//                 appendToDelimitedField("reasons", "Academic preparation aligns with program rigor", "reasons")
//               }
//               className="rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-semibold hover:bg-slate-100"
//             >
//               + Aligns with program rigor
//             </button>
//             <div className="flex items-center gap-2">
//               <input
//                 value={customReason}
//                 onChange={(e) => setCustomReason(e.target.value)}
//                 placeholder="Custom reason…"
//                 className="w-72 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/30"
//               />
//               <button
//                 type="button"
//                 onClick={() => {
//                   appendToDelimitedField("reasons", customReason, "reasons");
//                   setCustomReason("");
//                 }}
//                 className="rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-1.5 text-white text-xs font-semibold shadow-md hover:from-teal-700 hover:to-orange-700"
//               >
//                 Add
//               </button>
//             </div>
//           </div>
//         </Field> */}
//       </div>

//       {/* ===== Experience ===== */}
//       <div className="grid gap-3">
//         <div className="flex flex-wrap items-center justify-between gap-2">
//           <span className="text-sm font-semibold text-slate-900">Counselor Experience with Student</span>
//           <button
//             type="button"
//             onClick={aiExperience}
//             className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-1.5 text-white text-sm font-semibold shadow-md hover:from-teal-700 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-teal-600/40 disabled:opacity-50"
//             disabled={aiBusy}
//           >
//             {aiBusy ? (
//               <>
//                 <Spinner className="h-4 w-4 text-white" /> AI drafting…
//               </>
//             ) : (
//               "AI: Draft experience"
//             )}
//           </button>
//         </div>

//         <Field label="AI Prompt (optional)">
//           <div className="grid gap-2">
//             <Select
//               defaultValue=""
//               onChange={(e) => {
//                 const v = e.target.value;
//                 if (!v) return;
//                 if (v === "__clear__") {
//                   setField("ai_experience_prompt")({ target: { value: "" } });
//                   return;
//                 }
//                 setField("ai_experience_prompt")({ target: { value: v } });
//                 pushHistory("ai_experience_prompt", v);
//               }}
//             >
//               <option value="" disabled>
//                 — Choose a preset —
//               </option>
//               {aiPresets.map((p) => (
//                 <option key={p.id} value={p.value}>
//                   {p.label}
//                 </option>
//               ))}
//               <option value="__clear__">Clear custom prompt</option>
//             </Select>

//             <input
//               placeholder="Or type your own prompt…"
//               className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
//               value={form.ai_experience_prompt}
//               onChange={setField("ai_experience_prompt")}
//               onBlur={(e) => pushHistory("ai_experience_prompt", e.target.value)}
//               list="hist-ai_experience_prompt"
//             />
//             <HistoryDatalist id="hist-ai_experience_prompt" values={history["ai_experience_prompt"] || []} />
//           </div>
//         </Field>

//         <Field hint="Review & edit before generating the final letter.">
//           <textarea
//             ref={expRef}
//             rows={4}
//             placeholder="Describe concrete interactions, growth observed, and contributions to school community."
//             className={[
//               "w-full rounded-xl border bg-white px-3 py-2.5 shadow-sm outline-none",
//               "border-gray-200 focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100",
//               aiGlow ? "ring-2 ring-teal-600/30 border-teal-600/30" : "",
//             ].join(" ")}
//             value={form.experience}
//             onChange={setField("experience")}
//             onBlur={(e) => pushHistory("experience", e.target.value)}
//             list="hist-experience"
//           />
//           <HistoryDatalist id="hist-experience" values={history["experience"] || []} />
//           <label className="mt-2 inline-flex items-center gap-2 select-none">
//             <input
//               type="checkbox"
//               className="accent-teal-600"
//               checked={form.include_experience}
//               onChange={setField("include_experience")}
//             />
//             <span className="text-sm text-gray-700">Include this paragraph in the final letter</span>
//           </label>
//         </Field>
//       </div>

//       {/* Note: keep the "Personal Story" textarea in the parent to preserve your history flow */}
//     </div>
//   );
// }


// app/components/form-sections/EvidenceExperienceSection.jsx
"use client";

import Field from "../ui/Field";
import Select from "../ui/Select";
import { HistoryDatalist } from "../ui/HistoryDatalist";
import Spinner from "../ui/Spinner";
import { useRef, useEffect } from "react";

export default function ExperienceSection({
  form,
  setField,
  pushHistory,
  history,
  aiExperience,
  aiBusy,
  aiGlow,
  aiPresets = [],
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (aiGlow) {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [aiGlow]);

  return (
    <div className="grid gap-3 mt-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-sm font-semibold text-slate-900">
          Counselor Experience with Student
        </span>
        <button
          type="button"
          onClick={aiExperience}
          className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-teal-600 to-orange-600 px-3 py-1.5 text-white text-sm font-semibold shadow-md hover:from-teal-700 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-teal-600/40 disabled:opacity-50"
          disabled={aiBusy}
        >
          {aiBusy ? (
            <>
              <Spinner className="h-4 w-4 text-white" /> AI drafting…
            </>
          ) : (
            "AI: Draft experience"
          )}
        </button>
      </div>

      <Field label="AI Prompt (optional)">
        <div className="grid gap-2">
          <Select
            defaultValue=""
            onChange={(e) => {
              const v = e.target.value;
              if (!v) return;
              if (v === "__clear__") {
                setField("ai_experience_prompt")({ target: { value: "" } });
                return;
              }
              setField("ai_experience_prompt")({ target: { value: v } });
              pushHistory("ai_experience_prompt", v);
            }}
          >
            <option value="" disabled>
              — Choose a preset —
            </option>
            {aiPresets.map((p) => (
              <option key={p.id} value={p.value}>
                {p.label}
              </option>
            ))}
            <option value="__clear__">Clear custom prompt</option>
          </Select>

          <input
            placeholder="Or type your own prompt…"
            className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
            value={form.ai_experience_prompt}
            onChange={setField("ai_experience_prompt")}
            onBlur={(e) => pushHistory("ai_experience_prompt", e.target.value)}
            list="hist-ai_experience_prompt"
          />
          <HistoryDatalist
            id="hist-ai_experience_prompt"
            values={history["ai_experience_prompt"] || []}
          />
        </div>
      </Field>

      <Field hint="Review & edit before generating the final letter.">
        <textarea
          ref={ref}
          rows={4}
          placeholder="Describe concrete interactions, growth observed, and contributions to school community."
          className={[
            "w-full rounded-xl border bg-white px-3 py-2.5 shadow-sm outline-none",
            "border-gray-200 focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100",
            aiGlow ? "ring-2 ring-teal-600/30 border-teal-600/30" : "",
          ].join(" ")}
          value={form.experience}
          onChange={setField("experience")}
          onBlur={(e) => pushHistory("experience", e.target.value)}
          list="hist-experience"
        />
        <HistoryDatalist id="hist-experience" values={history["experience"] || []} />
        <label className="mt-2 inline-flex items-center gap-2 select-none">
          <input
            type="checkbox"
            className="accent-teal-600"
            checked={form.include_experience}
            onChange={setField("include_experience")}
          />
          <span className="text-sm text-gray-700">
            Include this paragraph in the final letter
          </span>
        </label>
      </Field>
    </div>
  );
}
